import { useState, useContext, useEffect } from "react";
import BGImage from "../../assets/images/bgimages.png";
import { Input, Button } from "antd";
import SearchProvider from "../../Provider/SearchProvider";
import { useNavigate } from "react-router-dom";
import { ArrowRightOutlined } from "@ant-design/icons";
import Meta from "../../Meta/Meta";

const Home = () => {
  const navigate = useNavigate();
  const [forpatients, setForpatients] = useState("patients");
  const { searchTable, setSearchTable } = useContext(SearchProvider);
  useEffect(() => {
    setSearchTable({
      ...searchTable,
      search: "",
    });
  }, []); // Dependency array ensures it runs once on mount

  const onSearch = (event) => {
    const value = event.target.value; // Extract the value from the input event
    setSearchTable((prev) => ({ ...prev, search: value })); // Update the searchTable state
  };
  return (
    <>
      <Meta slug="home" />
      <div className="relative">
        <img src={BGImage} className="w-[100%] h-[100vh] object-cover" />
        <div className="absolute  top-[50%]  left-[50%] translate-x-[-50%] translate-y-[-50%] w-full">
          <div className="container">
            <div className="w-[100%] md:w-[40%] font-secondary font-normal text-[40px] text-white text-center md:text-left">
              Locate a BioAlign certified doctor near you
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[2rem] md:gap-[5rem] px-4 py-3  mt-10 items-center">
              <div className="bg-white rounded-2xl ">
                <h2 className="font-secondary text-black font-normal text-[2rem] px-10 pt-10">
                  Search for clinic/doctor
                </h2>
                <div className="flex px-10 pb-10 gap-5">
                  <Input
                    value={searchTable?.search}
                    placeholder="Enter pin code/location or use my location"
                    className="mt-5"
                    size="large"
                    onChange={onSearch}
                    style={{ borderRadius: "10px", width: "80%" }}
                  />
                  <button
                    className=" w-[150px] bg-primary  mt-5 text-white font-secondary font-medium text-[1.4rem] rounded-md hover:bg-milkgreen hover:text-white transition duration-300"
                    onClick={() =>
                      navigate(`/search?search=${searchTable?.search}`)
                    }
                  >
                    Search
                  </button>
                </div>
              </div>
              {/* <div className=" bg-gray-300 rounded-xl">
                <h3 className="font-secondary font-normal text-[2rem] text-white text-center md:text-left">
                  Or let us help you to find a suitable appointment
                </h3>
                <button className="bg-white text-primary py-4 px-8 rounded-xl text-[16px] font-medium mt-5 block mx-auto md:mx-0">
                  Request an Appointment
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="my-[10vh]">
        <div className="container">
          <h3 className="font-secondary font-medium text-[2rem]">Disclaimer</h3>
          <p className="font-primary font-thin text-[1.6rem] mt-8 text-[#666363] text-justify md:text-left">
            We believe that a smile is not just a reflection of good oral
            health, but also a powerful first impression that can leave a
            lasting impact.
          </p>
        </div>
      </div>
    </>
  );
};

export default Home;
